import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const KEY = 'dw_ws_link';

// Per-tab "working in a linked team workspace" choice; sent as X-Workspace-Id (server checks it's allowed).
export const getLinkedWs = () => sessionStorage.getItem(KEY) || '';
export const setLinkedWs = (id) => { if (id) sessionStorage.setItem(KEY, id); else sessionStorage.removeItem(KEY); };

// A shared Client Portal link from a linked broker: find its workspace, switch this tab to it and reload.
export const openInRightWorkspace = async (appId) => {
  try {
    const { data } = await axios.get(`${API}/api/onboarding/workspace-locate/${appId}`, { headers: { 'X-Workspace-Id': '' } });
    const target = data.home ? '' : data.workspace_id;
    if (target === getLinkedWs()) return false;
    setLinkedWs(target);
    window.location.reload();
    return true;
  } catch {
    return false;
  }
};
